module.exports = __webpack_public_path__ + "img/div.86f6e4a0.svg";